const Icons = {
  Add: 'ic:twotone-post-add',
  Edit: 'iconoir:page-edit',
  Delete: 'material-symbols:folder-delete-outline',
  Search: 'ant-design:file-search-outlined',
  Submit: 'iconoir:submit-document',
  Preview: 'material-symbols:preview-outline', // Fixed typo from "prew"
  Filter: 'ep:filter',
  Login: 'solar:login-3-line-duotone',
  Logout: 'solar:logout-3-line-duotone',
  Import: 'stash:file-import-duotone',
  Back: 'icon-park-twotone:back',
  Next: 'icon-park-twotone:next',
  Document: 'line-md:document-list-twotone',
  Email: 'line-md:email-twotone',
  Phone: 'ic:twotone-phone-iphone',
  Address: 'mdi:address-marker-outline',
  Bank: 'pepicons-print:bank',
  Contact: 'wpf:business-contact',
  Company: 'fluent-mdl2:company-directory',
  Circle: 'fluent:tag-circle-20-regular',
  Category: 'carbon:category-add',
  No: 'iconamoon:shield-no-duotone',
  Yes: 'iconamoon:shield-yes-duotone',
  Branch:'icon-park-twotone:branch-one',
  Menu:'gg:menu-round',
};

export default Icons;
